import { LIBRARY } from '../const';
import * as Promise from 'bluebird';
import * as transformerService from '../services/cmi5/transformerService';
import * as CustomTranslate from '../services/translate/customTranslateService';
import * as _ from 'lodash';
import * as backofficeApi from '../services/api/backofficeApi';
import * as bookActions from './bookActions';
import * as messageAlert from './messageAlertAction';
import { I18n } from 'react-redux-i18n-lite';
import { checkFiltersApplied } from '../services/domain/libraryService';
import { REDUCER } from '../reducers/reducersConst';
import * as bookApi from '../services/api/bookApi';
import { importLessonsIntoUnit, importUnitsIntoBook } from '../services/api/classroomApi';
import { setDrawerClosed, setDrawerData } from './drawerActions';
import { getBookInfo } from './bookActions';
import * as bookService from '../services/domain/bookService';
import { ANALYTICS_CONTEXT } from '../types/analytics';

export let setOpenPreview = (previewBook = undefined, creatingUnit = false) => {
  return {
    type: REDUCER.LIBRARY.SET_OPEN_PREVIEW,
    previewBook,
    creatingUnit
  };
};

export let setFetchingPreview = (isFetchingPreview = undefined) => {
  return {
    type: REDUCER.LIBRARY.SET_FETCHING_PREVIEW,
    isFetchingPreview
  };
};

export let setPrimaryBooks = (primaryBooks = []) => {
  return {
    type: REDUCER.LIBRARY.SET_PRIMARY_BOOKS,
    primaryBooks
  };
};

export let addUnitId = unitId => {
  return {
    type: REDUCER.LIBRARY.ADD_UNIT_ID,
    unitId
  };
};

export let removeUnitId = unitId => {
  return {
    type: REDUCER.LIBRARY.REMOVE_UNIT_ID,
    unitId
  };
};

export let removeAllUnitIds = () => {
  return {
    type: REDUCER.LIBRARY.REMOVE_ALL_UNIT_ID
  };
};

export let requestFilteredBook = (institutionId, metadataToSearch, currentTags, newPage, currentPaginator) => {
  return {
    type: REDUCER.LIBRARY.REQUEST_FILTERED_BOOKS,
    payload: {
      institutionId,
      metadataToSearch,
      currentTags,
      newPage,
      maxPageSize: LIBRARY.MAX_PAGE_SIZE_FILTERED,
      currentPaginator
    }
  };
};

export let setFilteredBooks = (filteredBooks = []) => {
  return {
    type: REDUCER.LIBRARY.SET_FILTERED_BOOKS,
    filteredBooks
  };
};

export let addFilter = (type, selection) => {
  return (dispatch, getState) => {
    let oldFilters = getState().library.currentFilters;
    let newFilters = JSON.parse(JSON.stringify(oldFilters));

    if (!newFilters[type]) {
      newFilters[type] = [];
    }
    newFilters[type].push(selection);

    dispatch(setCurrentFilters(newFilters));
    if (type !== LIBRARY.FILTER_TYPE.OTHERS_FILTER) {
      dispatch(removeFilter(LIBRARY.FILTER_TYPE.OTHERS_FILTER, -1));
    }
  };
};

export let removeFilter = (type, selection) => {
  return (dispatch, getState) => {
    let oldFilters = getState().library.currentFilters;
    let newFilters = Object.assign({}, oldFilters);
    _.remove(newFilters[type], s => s === selection);
    dispatch(setCurrentFilters(newFilters));
  };
};

export let removeTags = () => {
  return {
    type: REDUCER.LIBRARY.REMOVE_TAGS,
    tags: []
  };
};

export let removeTag = tag => {
  return {
    type: REDUCER.LIBRARY.REMOVE_TAG,
    tag
  };
};

export let removeSearchConfig = () => {
  return {
    type: REDUCER.LIBRARY.REMOVE_SEARCH_CONFIG
  };
};

export let addTag = tag => {
  return {
    type: REDUCER.LIBRARY.ADD_TAG,
    tag
  };
};

export let setCurrentFilters = (currentFilters = {}) => {
  return {
    type: REDUCER.LIBRARY.SET_CURRENT_FILTERS,
    currentFilters
  };
};

export let setFilters = (filters = []) => {
  return {
    type: REDUCER.LIBRARY.SET_FILTERS,
    filters
  };
};

export let setClosedFilters = closedFilters => {
  return {
    type: REDUCER.LIBRARY.SET_CLOSED_FILTERS,
    closedFilters
  };
};

export let setImportReveal = (importReveal = null) => {
  return {
    type: REDUCER.LIBRARY.SET_IMPORT_REVEAL,
    importReveal
  };
};

export let setImportVinculationReveal = (importVinculationReveal = null) => {
  return {
    type: REDUCER.LIBRARY.SET_IMPORT_VINCULATION_REVEAL,
    importVinculationReveal
  };
};

export let setImportIsFetching = (importIsFetching = null) => {
  return {
    type: REDUCER.LIBRARY.SET_IMPORT_IS_FETCHING,
    importIsFetching
  };
};

/**
 * Sets the state (open/close) of the reveal to confirm a book importation
 * @param importFinishedReveal
 * @returns {{type: string, importFinishedReveal: boolean}}
 */
export let setImportFinishedReveal = (importFinishedReveal = false) => {
  return {
    type: REDUCER.LIBRARY.SET_IMPORT_FINISHED_REVEAL,
    importFinishedReveal
  };
};

export let addPrimaryBooks = (metadataValueId, books) => {
  return (dispatch, getState) => {
    let primaryBooks = getState().library.primaryBooks;

    let primaryBook = {};
    primaryBook.metadataId = metadataValueId;
    primaryBook.books = books;
    if (!primaryBooks) {
      primaryBooks = [];
    }
    primaryBooks.push(primaryBook);
    let noMetadataBooks = _.find(primaryBooks, books => !books.metadataId);
    if (noMetadataBooks) {
      _.pull(primaryBooks, noMetadataBooks);
      primaryBooks.push(noMetadataBooks);
    }

    dispatch(setPrimaryBooks(primaryBooks));
  };
};

export let getLibraryBooksByMetadataValue = (metadataId, metadataValueId) => {
  return (dispatch, getState) => {
    let state = getState();
    let institutionId = state.school.school.id;
    if (institutionId) {
      const page = 0;

      let metadata;
      if (metadataId && metadataValueId) {
        metadata = {};
        metadata[metadataId] = [metadataValueId];
      }

      return backofficeApi.getLibraryBooks(institutionId, metadata, [], page, LIBRARY.MAX_PAGE_SIZE).then(res => {
        let books = transformerService.transformCMI5ToLibrary(res.data._embedded);
        dispatch(addPrimaryBooks(metadataValueId, books));
        return books;
      });
    }
  };
};

export let loadLibraryBookContent = (book, creatingUnit) => {
  return (dispatch, getState) => {
    dispatch(setFetchingPreview(true));
    dispatch(setOpenPreview(book, creatingUnit));
    if (!book.content || book.content.length === 0) {
      let state = getState();
      let institutionId = state.school.school.id;
      if (institutionId && book.activityId) {
        return backofficeApi.getLibraryBook(institutionId, book.activityId).then(res => {
          let books = transformerService.transformCMI5ToLibrary([res.data]);
          dispatch(setOpenPreview(books[0], creatingUnit));
          dispatch(setFetchingPreview(false));
        });
      }
    }
    dispatch(setFetchingPreview(false));
  };
};

let getMetadataFilterToSearch = (currentFilters, filters) => {
  if (!currentFilters) return {};

  let results = {};

  if (currentFilters[LIBRARY.FILTER_TYPE.PRIMARY_FILTER]) {
    let filter = _.find(filters, { metadataFilterType: LIBRARY.FILTER_TYPE.PRIMARY_FILTER });
    results[filter.id] = currentFilters[LIBRARY.FILTER_TYPE.PRIMARY_FILTER];
  }

  if (currentFilters[LIBRARY.FILTER_TYPE.SECONDARY_FILTER]) {
    let filter = _.find(filters, { metadataFilterType: LIBRARY.FILTER_TYPE.SECONDARY_FILTER });
    results[filter.id] = currentFilters[LIBRARY.FILTER_TYPE.SECONDARY_FILTER];
  }

  if (currentFilters[LIBRARY.FILTER_TYPE.TERTIARY_FILTER]) {
    let filter = _.find(filters, { metadataFilterType: LIBRARY.FILTER_TYPE.TERTIARY_FILTER });
    results[filter.id] = currentFilters[LIBRARY.FILTER_TYPE.TERTIARY_FILTER];
  }

  let othersFilter = currentFilters[LIBRARY.FILTER_TYPE.OTHERS_FILTER];
  if (othersFilter && othersFilter.length > 0) {
    let filter = _.find(filters, { metadataFilterType: LIBRARY.FILTER_TYPE.PRIMARY_FILTER });
    if (!filter) {
      filter = _.find(filters, { metadataFilterType: LIBRARY.FILTER_TYPE.OTHERS_FILTER });
    }
    results = results[filter.id] && results[filter.id].length ? results : undefined;
  }

  return results;
};

export let getLibraryBooksFiltered = newPage => {
  return (dispatch, getState) => {
    let state = getState();
    let institutionId = state.school.school.id;

    if (institutionId) {
      let currentFilters = state.library.currentFilters;
      let filters = state.library.filters;
      let currentTags = state.library.tags;

      if (checkFiltersApplied(currentFilters) || currentTags) {
        const currentPaginator = state.library.paginator || {};
        const metadataToSearch = getMetadataFilterToSearch(currentFilters, filters);

        // to remove paginator while request is being processed
        currentPaginator.total = 0;
        dispatch(setPaginator(currentPaginator));
        dispatch(requestFilteredBook(institutionId, metadataToSearch, currentTags, newPage, currentPaginator));
      }
    }
  };
};

export let getBookName = (book = {}) => {
  return (dispatch, getState) => {
    let store = getState();
    let language = store.account.user.language;
    let bookTitle = '';

    if (book && book.name && language) {
      bookTitle = CustomTranslate.translateObject(book.name, language);
    }

    return Promise.resolve(bookTitle);
  };
};

export let addClosedFilter = (filterId = undefined) => {
  return (dispatch, getState) => {
    let store = getState();

    if (filterId && !_.includes(store.library.closedFilters, filterId)) {
      let newFilters = JSON.parse(JSON.stringify(store.library.closedFilters));
      newFilters.push(filterId);
      dispatch(setClosedFilters(newFilters));
      return Promise.resolve(newFilters);
    }
  };
};

export let removeClosedFilter = (filterId = undefined) => {
  return (dispatch, getState) => {
    let store = getState();

    if (filterId && _.includes(store.library.closedFilters, filterId)) {
      let index = store.library.closedFilters.indexOf(filterId);
      if (index > -1) {
        let newFilters = JSON.parse(JSON.stringify(store.library.closedFilters));
        newFilters.splice(index, 1);
        dispatch(setClosedFilters(newFilters));
        return Promise.resolve(newFilters);
      }
    }
  };
};

export let getLibraryFilters = () => {
  return (dispatch, getState) => {
    let state = getState();
    let customerId = state.account.configuration.customerId;
    if (customerId) {
      return backofficeApi
        .getLibraryFilters(customerId)
        .then(res => {
          let filters = res.data;
          if (_.isEmpty(filters)) {
            filters.push({
              id: -1,
              name: 'Others',
              metadataFilterType: LIBRARY.FILTER_TYPE.OTHERS_FILTER,
              metadataValues: []
            });
          }
          dispatch(setFilters(res.data));
          return res.data;
        })
        .catch(err => {});
    }
    return Promise.resolve();
  };
};

/**
 * Import a book from the library to all selected classrooms
 * @param {string} activityId
 * @param classrooms
 * @returns {function(*)}
 */
export const importBookToCheckedClassrooms = (
  activityId,
  classrooms,
  forceOriginal,
  unlinked,
  fromSectionId,
  isCopy
) => {
  return dispatch => {
    classrooms = classrooms.filter(classroom => classroom.checked);

    return dispatch(
      importLibraryBooksToClassrooms(classrooms, activityId, forceOriginal, unlinked, fromSectionId, isCopy)
    );
  };
};

export let setImportRevealData = (importReveal = {}, creatingUnit) => {
  return async dispatch => {
    let classroomsWithImportedBook = await bookApi.getClassesWithBookImported(importReveal.activityId);
    importReveal.classroomsWithImportedBook = classroomsWithImportedBook.data;
    dispatch(setImportReveal(importReveal, creatingUnit));
  };
};

export const importUnitToClassroom = (
  bookActivityId,
  classroom,
  selectedUnitId,
  bookId,
  fromSectionId,
  context,
  unlinked = true
) => {
  return async dispatch => {
    try {
      const classroomId = typeof classroom === 'object' ? classroom.id : classroom;
      const originSectionId = sanitizeImportOrigin(fromSectionId, classroomId);
      dispatch(setImportIsFetching(bookActivityId));
      await importUnitsIntoBook(
        classroomId,
        bookId,
        selectedUnitId,
        bookActivityId,
        originSectionId,
        context,
        originSectionId ? unlinked : true
      );
      dispatch(setImportIsFetching());
      dispatch(removeAllUnitIds());
      dispatch(messageAlert.info(`${I18n.t('library.importUnitSuccess')}`));
    } catch (err) {
      if (err.response.status === 409) {
        dispatch(messageAlert.error(`${I18n.t('library.unitAlreadyImported')}`));
      }
      dispatch(setImportIsFetching());
      dispatch(removeAllUnitIds());
    }
    dispatch(setImportFinishedReveal(true));
  };
};

export const importLessonsToUnitClassroom = (
  classroom,
  bookId,
  unitActivityId,
  lessonActivityIds,
  context,
  fromSectionId,
  unlinked = true
) => {
  return async dispatch => {
    try {
      const classroomId = typeof classroom === 'object' ? classroom.id : classroom;
      const originSectionId = sanitizeImportOrigin(fromSectionId, classroomId);
      dispatch(setImportIsFetching(unitActivityId));
      await importLessonsIntoUnit(
        classroomId,
        bookId,
        unitActivityId,
        lessonActivityIds,
        context,
        originSectionId,
        originSectionId ? unlinked : true
      );
      dispatch(setImportIsFetching());
      dispatch(removeAllUnitIds());
      dispatch(messageAlert.info(`${I18n.t('library.importLessonToUnitSuccess')}`));
      dispatch(getBookInfo(classroomId, bookId));
    } catch (err) {
      if (err.response.status === 409) {
        dispatch(messageAlert.error(`${I18n.t('library.unitAlreadyImported')}`));
      }
      dispatch(setImportIsFetching());
      dispatch(removeAllUnitIds());
    }
    dispatch(setDrawerData());
    dispatch(setDrawerClosed());
    dispatch(setImportFinishedReveal(true));
  };
};

/** Drop invented CMS origins (catalog, undefined string, same classroom). */
function sanitizeImportOrigin(fromSectionId, destinationClassroomId) {
  if (
    !fromSectionId ||
    fromSectionId === 'catalog' ||
    fromSectionId === 'undefined' ||
    fromSectionId === destinationClassroomId
  ) {
    return undefined;
  }
  return fromSectionId;
}

export const importLibraryBooksToClassrooms = (
  classrooms,
  activityId,
  forceOriginal,
  unlinked,
  fromSectionId,
  isCopy
) => {
  return (dispatch, getState) => {
    const importBookPayload = classrooms.map(classroom => {
      return {
        classroomId: typeof classroom === 'string' ? classroom : classroom.id,
        bookId: activityId,
        forceOriginal,
        unlinked,
        fromSectionId,
        context: isCopy ? ANALYTICS_CONTEXT.BOOK_COPY : ANALYTICS_CONTEXT.BOOK_IMPORT
      };
    });

    dispatch(setImportIsFetching(activityId));
    dispatch(setImportReveal());
    const overrideBook = getState().account.configuration.overrideOnBookImport;

    return bookApi.importSeveralBooks(importBookPayload, overrideBook).then(({ data }) => {
      const state = getState();
      dispatch(setImportIsFetching());

      const selectedClassroomId = state.classrooms.selectedClassroom.classroom.id;
      const errorMessage = createCustomErrorMessage(classrooms, data.errors);
      const classroomIds = data.books.map(book => book.sectionId);
      const classroomNames = classrooms
        .filter(classroom => classroomIds.includes(classroom.id))
        .map(classroom => classroom.name);

      if (data.errors.length > 0 && data.books.length > 0) {
        dispatch(messageAlert.warning(`<p>${getSuccessMessage(isCopy, classroomNames)}</p><p>${errorMessage}</p>`));
      } else {
        if (errorMessage) {
          dispatch(messageAlert.error(errorMessage));
        } else {
          dispatch(messageAlert.info(getSuccessMessage(isCopy, classroomNames)));
        }
      }

      if (selectedClassroomId) {
        dispatch(setImportFinishedReveal(true));
      }

      // TODO: should we dispatch this for every classroom or just for the selected classroom
      // importBookPayload.forEach(({ classroomId }) => dispatch(bookActions.getBooksData(classroomId)));
      if (selectedClassroomId) {
        dispatch(bookActions.getBooksData(selectedClassroomId));
      }
    });
  };
};
export const getSuccessMessage = (isCopy, classroomNames) => {
  if (isCopy) {
    return I18n.t('common.copySuccess', { classroom: classroomNames.join(', ') });
  }
  return I18n.t('library.importSuccess.header', { classroom: classroomNames.join(', ') });
};

/**
 * Updates paginator object with first, last, current page links and total pages
 * @param paginator
 * @returns {{type: string, paginator: {}}}
 */
export let setPaginator = (paginator = {}) => {
  return {
    type: REDUCER.LIBRARY.SET_PAGINATOR,
    paginator
  };
};

export let loadLibraryPrimaryBooks = () => {
  return dispatch => {
    dispatch(getLibraryFilters()).then(filters => {
      if (filters) {
        let hasMetadataValues = false;
        for (let idFilter = 0; idFilter < filters.length; idFilter++) {
          let filter = filters[idFilter];
          if (filter.metadataFilterType === LIBRARY.FILTER_TYPE.PRIMARY_FILTER) {
            if (filter.metadataValues) {
              for (let idMeta = 0; idMeta < filter.metadataValues.length; idMeta++) {
                let metadataValue = filter.metadataValues[idMeta];
                dispatch(getLibraryBooksByMetadataValue(filter.id, metadataValue.id));
                hasMetadataValues = true;
              }
            }
          }
        }
        dispatch(getLibraryBooksByMetadataValue());
        if (!hasMetadataValues) dispatch(setPrimaryBooks());
      }
    });
  };
};

export let openImportVinculationReveal = (importVinculationReveal = null, bookId = null, creatingUnit = {}) => {
  return async dispatch => {
    if (bookId) {
      let classroomsGroupsWithBook = await bookApi.getClassroomsGroupsWithBook(creatingUnit.selectedUnitId || bookId);
      if (classroomsGroupsWithBook.data.length) {
        importVinculationReveal.classroomsGroupsWithBook = classroomsGroupsWithBook.data;
        dispatch(setImportVinculationReveal(importVinculationReveal));
      } else {
        if (!creatingUnit.creatingUnit) {
          dispatch(importBookToCheckedClassrooms(bookId, importVinculationReveal.classrooms, true, false));
        } else {
          dispatch(
            importUnitToClassroom(
              creatingUnit.bookActivityId,
              creatingUnit.classroom,
              creatingUnit.selectedUnitId,
              creatingUnit.bookId,
              undefined
            )
          );
        }
      }
    }
  };
};

export let createCustomErrorMessage = (classrooms, errors) => {
  let customErrorData = {
    classrooms: [],
    i18nMessage: ''
  };

  errors.map(({ classroomId, bookId, error }) => {
    const classroom = _.find(classrooms, { id: classroomId });
    customErrorData.classrooms.push(classroom.name);
    if (error.code === 'error.library.bookAlreadyImported') {
      customErrorData.i18nMessage = 'library.alreadyImported';
    } else if (error.code === 'error.library.bookActivityAlreadyImported') {
      customErrorData.i18nMessage = 'library.bookActivityAlreadyImported';
    } else {
      customErrorData.i18nMessage = 'library.importError';
    }
    return error;
  });

  if (!_.isEmpty(customErrorData.classrooms)) {
    return I18n.t(customErrorData.i18nMessage, { classrooms: customErrorData.classrooms.join(', ') });
  }

  return '';
};

// libraryActions.jsx
export const cloneLessonToClassroom = (lessonActivityId, importFrom, classroomId, bookId, unitActivityId, context) => {
  return async dispatch => {
    try {
      if (!lessonActivityId) {
        dispatch(messageAlert.error(I18n.t('lessonCard.lessonClonedError')));
        return;
      }

      await bookService.cloneLesson(lessonActivityId, importFrom, classroomId, bookId, unitActivityId, context);
      dispatch(getBookInfo(classroomId, bookId));
      dispatch(messageAlert.success(I18n.t('lessonCard.lessonClonedSuccess')));
    } catch (error) {
      console.error('Error al clonar lección desde catálogo:', error);
      const errorMessage = error.response?.data?.message || I18n.t('lessonCard.lessonClonedError');
      dispatch(messageAlert.error(errorMessage));
    }
  };
};
